// Design tokens from the "CWP-UI-Layouts-Importing-v1" style guide, kept in step
// with the mobile app's theme (createwithpixels-app src/theme/color.tsx) so the
// editor inside the WebView looks like the rest of the app.
export const ui = {
	page: '#333333', // screen background
	card: '#333333', // modal cards
	bar: '#1A1A1A', // tool bars and option panels
	label: '#A6A6A6', // secondary text, tool labels, slider thumbs
	text: '#FFFFFF',
	gold: '#FFC100', // primary accent
	onGold: '#1A1A1A', // text on gold buttons
	input: '#4D4D4D',
	divider: 'rgba(166, 166, 166, 0.35)',
	error: '#CC4031',
	font: "'Poppins', sans-serif",
};
